import React from 'react'
import { prop } from 'ramda'
import PropTypes from 'prop-types'
import Grid from '@mui/material/Grid'
import { useParams } from 'react-router-dom'

import { Button } from '~/components/Buttons'
import PageTitle from '~/components/PageTitle'
import Container, { Content, Header } from '~/components/Container'
import * as NAV from '~/constants/nav-titles'
import { RECEIVE_TABS } from '~/constants/tabs'
import History from '~/components/History'
import LoaderProvider from '~/components/Loader'

import PurchaseReceiveGeneral from './PurchaseReceiveGeneral'
import ReceivePurchaseOrderTabs from './ReceivePurchaseOrderTabs'

import { COMPLETED } from '../../constants'

function ReceivePurchaseOrderDetail (props) {
  const {
    pageTitle,
    pageTitleLoading,
    isLoading,
    completeDisabled,
    values,
    onComplete,
    handleReceive,
    receiveHistory,
    getVariantDetail
  } = props

  const { guid, tab } = useParams()

  const receiptStatus = prop('receiptStatus', values)

  const disabled = (
    isLoading ||
    completeDisabled ||
    receiptStatus === COMPLETED
  )

  return (
    <LoaderProvider isLoading={isLoading}>
      <Container>
        <Header>
          <PageTitle
            pageTitle={pageTitle}
            pageTitleLoading={pageTitleLoading}
            parentTitle={NAV.RECEIVE}
            rightButton={(
              <>
                <Button
                  variant="contained"
                  type="button"
                  data-cy="receive"
                  onClick={handleReceive}
                  disabled={disabled}
                >
                  Receive
                </Button>
                <Button
                  disabled={disabled}
                  variant="contained"
                  onClick={onComplete}
                  data-cy="complete"
                >
                  Complete
                </Button>
              </>
            )}
          />
        </Header>

        <Content>
          <ReceivePurchaseOrderTabs guid={guid} value={tab} />
          <Grid container={true} spacing={3}>
            <Grid item={true} xs={12}>
              {tab === RECEIVE_TABS.GENERAL && (
                <PurchaseReceiveGeneral
                  values={values}
                  isLoading={isLoading}
                  getVariantDetail={getVariantDetail}
                />
              )}
              {tab === RECEIVE_TABS.HISTORY && <History history={receiveHistory} />}
            </Grid>
          </Grid>
        </Content>
      </Container>
    </LoaderProvider>
  )
}

ReceivePurchaseOrderDetail.propTypes = {
  pageTitle: PropTypes.node.isRequired,
  pageTitleLoading: PropTypes.bool.isRequired,
  values: PropTypes.object.isRequired,
  handleReceive: PropTypes.func.isRequired,
  onComplete: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  completeDisabled: PropTypes.bool.isRequired,
  receiveHistory: PropTypes.object.isRequired,
  getVariantDetail: PropTypes.func.isRequired
}

export default ReceivePurchaseOrderDetail
